import React, { useEffect } from "react";
import MainNavbar from "../MainNavbar/MainNavbar";
import MainFooter from "../MainFooter/MainFooter";
import BackToTop from "../../BackToTop/BackToTop";
import { useLocation } from "react-router-dom";

const DefaultLayout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when route changes
  }, [pathname]);
  return (
    <>
      <MainNavbar />
      <main>{children}</main>
      <MainFooter />
      <BackToTop />
    </>
  );
};

export default DefaultLayout;
